import React from 'react';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { Tooltip } from '@televet/kibble-ui/build/components/Tooltip';

const InputLabel = ({ label, description }: { label: string; description?: string }): JSX.Element => {
  return (
    <Flex gap={1}>
      <Text fontWeight="semibold">{label}</Text>
      {!!description && (
        <Tooltip label={description}>
          <Flex align="center">
            <Icon name="questionMarkCircle" size="xs" color="subtle" />
          </Flex>
        </Tooltip>
      )}
    </Flex>
  );
};

export default InputLabel;
